export default function ($translate) {
    return {
        KEYS: {
            DAY: 'DAY',
            WEEK: 'WEEK',
            MONTH: 'MONTH'
        },
        LABELS: {
            DAY: $translate.instant('planningGroup.days'),
            WEEK: $translate.instant('planningGroup.weeks'),
            MONTH: $translate.instant('planningGroup.months')
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/automated/planning/group/maxWorkingSince/index.js